import React from 'react';
import BackRow from 'components/BackRow/BackRow';
import Card from 'components/Card/Card';
import { EditText, EditableMultiSelect } from 'components/EditText/EditText';
import { post, dodelete, put, upload, get } from 'lib/comms';
import { DeleteDialog, MessageDialog } from 'components/Dialog/Dialog';
import SwitchBar from 'components/SwitchBar/SwitchBar';
import EditBrowse from 'components/EditBrowse/EditBrowse';

import './PromoBanner.css';

import * as S from './PromoBanner.styled';

import 'react-quill/dist/quill.snow.css';

export default class PromoBannerItem extends React.Component {
    constructor(props) {
        super(props);

        this.fileInputRef = React.createRef();
        const isNew = props.promoBannerItem && props.promoBannerItem.id === 'new';

        const banner = isNew
            ? {
                  id: 'new',
                  active: 1,
                  promotionName: '',
                  categories: [],
                  files: [
                      {
                          url: '',
                          file: '',
                      },
                  ],
              }
            : props.promoBannerItem;

        this.state = {
            ...banner,
            isNew,
            isEditing: isNew,
            selectedCategoriesToSave: null,
            selectedCategoriesToDisplay: null,
            categories: []
        };
    }

    getKnowledgebaseCategories = async () => {
        const resp = await get('cms/knowledgebase_categories', null, true);

        if (resp && resp.status === 401) {
            this.setState({ logout: true });
        }

        return resp && resp.categories ? resp.categories : [];
    };

    // Refresh the item
    reload = async () => {};

    async componentDidMount() {
        // Get all categories ids
        const [categories] = await Promise.all([this.getKnowledgebaseCategories(), this.reload()]);
        const categoriesWithMainFeed = [
            {
                id: "1",
                name: 'Main Feed',
                icon_colour: null,
                icon_name: null,
            },
            ...categories,
        ];
        this.setState({
            categories: categoriesWithMainFeed,
        });
        const allCategoriesId = categoriesWithMainFeed.map((item) => item.id).toString();

        //Get all promo banners and assigned categories
        let promoBanners = await get('cms/promo_banner', null, true);
        const bannerItems = Array.isArray(promoBanners)
            ? promoBanners
            : promoBanners.items || promoBanners.data || promoBanners.banners || [];
        const assignedCategories = bannerItems.flatMap((item) => item.categories || []);

        // Filter out assigned categories from all categories to get available categories for display in dropdown input field selection
        const availableIds = allCategoriesId.split(',').filter((item) => !assignedCategories.includes(item));
        const availableNames = categoriesWithMainFeed.filter((item) => availableIds.includes(item.id.toString()));
        // Find the categories to display in existing promo banners in display in input fields
        if (this.state.id && promoBanners.data) {
            const matchingObject = promoBanners.data.find(obj => obj.id === this.state.id);
            let categoriesToSave;
            if (matchingObject) {
                categoriesToSave = matchingObject.categories
                let categoriesToDisplay = []
                categoriesWithMainFeed.forEach(obj => {
                    for (let step = 0; step < categoriesToSave.length ; step++) {
                        if (categoriesToSave[step] == obj.id) {
                            categoriesToDisplay.push(`${obj.name}`)
                        }
                    }
                })
                this.setState({
                    selectedCategoriesToSave: categoriesToSave,
                    selectedCategoriesToDisplay: categoriesToDisplay,
                });
            }
        }

        this.setState({
            availableCategories: [...availableNames],
        });
    }

    // On toggle edit/save
    toggleEditingStatus = () => {
        const { isEditing } = this.state;
        this.setState({ isEditing: !isEditing });
    };

    onChangeFileUrl = (index, url) => {
        if (url.length > 254) return;
        let files = [...this.state.files];
        files[index] = {
            ...files[index],
            url: url,
        };

        this.setState({
            files: files,
        });
    };

    onChangePromotionName = (title) => {
        if (title.length > 254) return;
        this.setState({
            name: title,
        });
    };

    onFileChange = (file, index) => {
        let files = [...this.state.files];

        files[index] = {
            ...files[index],
            file: file,
            original_name: file.name,
        };

        this.setState({
            files: files,
        });
    };

    onClickAddFiles = () => {
        let files = [
            ...this.state.files,
            {
                url: '',
                file: '',
            },
        ];
        if (files.length > 5) {
            this.setState({
                showMessage: {
                    message: 'You can add maximum of 5 files',
                    title: 'Message',
                },
            });
            return;
        }

        this.setState({
            files: files,
        });
    };

    removeFile = (index) => {
        const files = [...this.state.files];
        files.splice(index, 1);

        this.setState({
            files: files,
        });
    };

    // Upload file items to backend before update/create of banner
    uploadFiles = async () => {
        const { files } = this.state;
        let fileIds = [];
        const fileCount = files.length;
        for (let index = 0; index < fileCount; index++) {
            const fileItem = files[index];
            if (!fileItem.id) {
                const fileResp = await upload(
                    `cms/upload_file/${fileItem.title}/promo_banner`,
                    'file',
                    fileItem.file,
                    true,
                );
                if (fileResp && fileResp['file_id']) {
                    fileIds.push({
                        fileId: fileResp['file_id'],
                        fileURL: fileItem.url,
                    });
                }
            } else {
                fileIds.push({
                    fileId: fileItem.file_id,
                    fileURL: fileItem.url,
                });
            }
        }
        return fileIds;
    };

    // on toggle edit/save
    toggleEditingStatus = () => {
        const { isEditing } = this.state;
        if (isEditing) {
            this.saveBanner();
        } else {
            this.setState({ isEditing: !isEditing });
        }
    };

    saveBanner = async () => {
        let bannerId = this.state.id;
        let resp = null;
        let { isEditing, files, active, name, selectedCategoriesToSave } = this.state;

        if (isEditing) {
            if (!name) {
                return this.setState({
                    showMessage: { message: 'Please include a valid title', title: 'Save Promotion Banner' },
                });
            }

            if (!files.length) {
                return this.setState({
                    showMessage: { message: 'Please add a valid banner', title: 'Save Promotion Banner' },
                });
            }

            for (let fileIndex = 0; fileIndex < files.length; fileIndex++) {
                const file = files[fileIndex];

                if (!file.original_name) {
                    return this.setState({
                        showMessage: { message: 'Please include a valid file', title: 'Save promotion Banner' },
                    });
                }
            }
        }

        const bannerItem = {
            name: name,
            active: active,
            selectedCategories: selectedCategoriesToSave || [],
        };

        const fileIds = await this.uploadFiles();

        bannerItem['fileIds'] = fileIds;

        if (this.state.isNew) {
            resp = await post('cms/promo_banner', bannerItem, true);
        } else {
            resp = await put(`cms/promo_banner/${this.state.id}`, bannerItem, true);
        }

        if (resp && resp.success) {
            this.setState({
                isNew: false,
                isEditing: false,
                id: resp.item ? resp.item.id : bannerId,
            });

            this.props.onBack();
        } else {
            this.setState({
                showMessage: { message: 'Could not create banner.', title: 'Save error' },
            });
        }
    };

    doDelete = async () => {
        const resp = await dodelete(`cms/promo_banner/${this.state.id}`, {}, true);
        if (resp && resp.success) {
            this.props.onBack();
        } else if (resp.message) {
            setTimeout(
                () =>
                    this.setState({
                        showMessage: {
                            message: resp.message,
                            title: 'Delete Banner',
                        },
                    }),
                500,
            );
        }
    };

    onCategoryChange = (values) => {
            const result = this.state.categories
    .filter(cat => values.includes(String(cat.id)))
    .map(cat => cat.name);              

    this.setState({
        selectedCategoriesToDisplay: result,
        selectedCategoriesToSave: values,
    })
}

    removeCategory = (selectedCategories, option, categories, availableCategories) => {
        const modifiedCategoriesToDisplay = selectedCategories.filter((item) => item !== option);
        const selectedCategoryNames = new Set(
            modifiedCategoriesToDisplay.map((name) => name)
        );

        const modifiedCategoryToSave = this.state.categories
            .filter((category) => selectedCategoryNames.has(category.name))
            .map((category) => String(category.id));

        const deletedCategory = categories.find((obj) => {
            if(obj.name === option) return obj
        })

        this.setState({
            availableCategories: [...availableCategories, deletedCategory],
            selectedCategoriesToDisplay: modifiedCategoriesToDisplay,
            selectedCategoriesToSave: modifiedCategoryToSave,
        });
    }

    render() {
        const { isEditing, files, name, active, selectedCategoriesToDisplay, selectedCategoriesToSave, availableCategories, categories } = this.state;

        return (
            <div className="maincontainer">
                <BackRow
                    onBack={this.props.onBack}
                    buttonTitle={this.state.isNew ? null : 'DELETE ITEM'}
                    onDelete={() => this.setState({ showDeleteDialog: true })}
                    accept="image/jpg, image/png"
                />

                <Card title="Promotional Banner" editing={isEditing} onToggle={this.toggleEditingStatus}>
                    <S.VerticalSpacer size={35} />

                    <SwitchBar
                        className="mb-4"
                        editing={isEditing ? '1' : undefined}
                        options={['Active', 'Archived']}
                        values={[1, 0]}
                        value={active}
                        onChange={(value) => this.setState({ active: value })}
                    />

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <EditText
                            outerClassName="mt-3 mb-3 mr-2 w-100"
                            label="Banner Name"
                            editing={isEditing}
                            onChange={(name) => this.onChangePromotionName(name)}
                            value={name}
                        />

                        <EditableMultiSelect
                            className="mt-3 mb-3 w-100"
                            label="Display In"
                            options={availableCategories}
                            editing={isEditing ? '1' : undefined}
                            value={selectedCategoriesToSave || []}
                            onChange={(values) => this.onCategoryChange(values)}
                        />
                        <div className='editable-multiselect-chip-container'>
                        {selectedCategoriesToDisplay?.map((option) => (
                            <button
                                key={option}
                                type="button"
                                className="editable-multiselect-chip"
                                disabled={!isEditing}
                                onClick={() => this.removeCategory(selectedCategoriesToDisplay, option, categories, availableCategories)}
                                
                            >
                            <span style={{color: "white"}}>{option}</span>

                            {isEditing && (
                                <span className="editable-multiselect-chip-remove">
                                    ×
                                </span>
                            )} 
                        </button>
                    ))}
                </div>
                    </div>

                    {files.map((file, index) => (
                        <S.FileContainer>
                            <EditText
                                outerClassName="mt-3 mb-3 w-50"
                                label="Promotion URL – optional"
                                editing={isEditing && !file.id}
                                onChange={(url) => this.onChangeFileUrl(index, url)}
                                value={file.url}
                            />
                            <S.HorizontalSpacer size={20} />
                            <EditBrowse
                                editing={isEditing && !file.id}
                                onFileChange={(slctdFile) => this.onFileChange(slctdFile, index)}
                                fileName={file['original_name']}
                                acceptFileTypes={'image/gif, image/jpeg, image/png'}
                            />
                            <S.HorizontalSpacer size={20} />
                            <button
                                className="btn btn-remove"
                                onClick={() => this.removeFile(index)}
                                disabled={!isEditing}
                                isEditing={isEditing && !file.id}
                            >
                                Remove
                            </button>
                        </S.FileContainer>
                    ))}

                    <S.BottomFileContainer>
                        <button
                            className="btn btn-primary knowledgebase-btn"
                            disabled={!isEditing}
                            onClick={this.onClickAddFiles}
                        >
                            ADD FILES
                        </button>
                    </S.BottomFileContainer>
                    {this.state.showMessage ? (
                        <MessageDialog
                            message={this.state.showMessage.message}
                            title={this.state.showMessage.title}
                            onClose={() => this.setState({ showMessage: null })}
                        />
                    ) : null}
                    {this.state.showDeleteDialog ? (
                        <DeleteDialog
                            item="Banner"
                            onSuccess={this.doDelete}
                            onClose={() => this.setState({ showDeleteDialog: false })}
                        />
                    ) : null}
                </Card>
            </div>
        );
    }
}

const localStyle = {
    subtitle: {
        fontSize: '15px',
        fontWeight: '400',
        letterSpacing: '-0.15px',
        color: '#000',
    },
    typeTitle: {
        fontSize: '15px',
        fontWeight: '400',
        letterSpacing: '-0.15px',
        color: '#000',
        marginLeft: 8,
    },
    TypeSubtitle: {
        fontSize: '15px',
        fontWeight: '400',
        letterSpacing: '-0.15px',
        color: '#505A62',
        textAlign: 'left',
        marginLeft: 8,
        marginTop: 3,
    },
};
